<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
        <div class="modal-wrapper">
          <div class="modal-content">
            <!-- 關閉按鈕 -->
            <button class="modal-close" @click="closeModal">&times;</button>

            <!-- 標題區域 -->
            <div class="modal-header">
              <h2 class="modal-title">推薦商品</h2>
            </div>

            <!-- 標籤頁切換 -->
            <div class="product-tabs">
              <button
                v-for="(product, index) in products"
                :key="product.id"
                :class="{ active: activeTab === index }"
                @click="activeTab = index"
                class="tab-button"
              >
                {{ product.name }}
              </button>
            </div>

            <!-- 產品內容區域 -->
            <div class="product-detail">
              <div class="product-image-container">
                <img
                  :src="products[activeTab].imageUrl"
                  :alt="products[activeTab].name"
                  class="product-image"
                  @click="openLightbox(products[activeTab].imageUrl)"
                />
                <!-- 圖片放大顯示 Lightbox -->
                <div
                  v-if="lightboxVisible"
                  class="lightbox"
                  @wheel.prevent="handleZoom"
                >
                  <!-- ✅ 新增關閉按鈕 -->
                  <button class="lightbox-close" @click="closeLightbox">
                    &times;
                  </button>

                  <!-- ✅ 外層容器負責拖曳 -->
                  <div
                    class="lightbox-zoom-container"
                    @mousedown="startDragging"
                    @mousemove="onDragging"
                    @mouseup="stopDragging"
                    @mouseleave="stopDragging"
                  ></div>

                  <img
                    :src="lightboxImage"
                    class="lightbox-image"
                    :style="zoomStyle"
                    draggable="false"
                    @mousedown="startDragging"
                    @mousemove="onDragging"
                    @mouseup="stopDragging"
                    @mouseleave="stopDragging"
                  />
                </div>
              </div>

              <div class="product-info">
                <h3 class="product-name">{{ products[activeTab].name }}</h3>
                <p class="product-description">
                  {{ products[activeTab].description }}
                </p>

                <h4 class="features-title">主要特點：</h4>
                <ul class="features-list">
                  <li
                    v-for="(feature, i) in products[activeTab].features"
                    :key="i"
                    class="feature-item"
                  >
                    <span class="feature-icon">✓</span>
                    <span class="feature-text">{{ feature }}</span>
                  </li>
                </ul>

                <div class="product-actions">
                  <button class="btn-secondary" @click="contactSupport">
                    聯絡客服
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
/* Base styles */
:root {
  --primary-color: #2c5e2e;
  --primary-hover: #1f4521;
  --secondary-color: #e07b39;
  --secondary-hover: #d06b29;
  --light-bg: #f8f8f8;
  --border-color: #e0e0e0;
}

.lightbox-zoom-container {
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
}

.lightbox-image {
  user-select: none;
}

.lightbox-close {
  position: absolute;
  top: clamp(10px, 2vh, 20px);
  right: clamp(10px, 2vw, 20px);
  font-size: clamp(1.5rem, 4vw, 1.75rem);
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  z-index: 2100;
  padding: clamp(6px, 1vw, 8px);
  transition: background-color 0.3s;
}

.lightbox-close:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Lightbox styles */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  cursor: zoom-out;
}

.lightbox-image {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: clamp(6px, 1vw, 8px);
  transform: scale(1);
}

/* Modal structure */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: clamp(10px, 2vw, 20px);
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.modal-content {
  background: white;
  border-radius: clamp(8px, 1.5vw, 12px);
  width: min(95%, 1100px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-close {
  position: absolute;
  top: clamp(18px, 1vh, 10px);
  right: clamp(8px, 1vw, 10px);
  background: none;
  border: none;
  font-size: clamp(1.25rem, 3vw, 1.5rem);
  color: #fff;
  cursor: pointer;
  z-index: 10;
  width: clamp(28px, 4vw, 32px);
  height: clamp(28px, 4vw, 32px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s;
}

.modal-close:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-header {
  background-color: #e07b39;
  color: rgb(3, 3, 3);
  text-align: center;
  padding: clamp(12px, 2vh, 15px) clamp(16px, 3vw, 20px);
}

.modal-title {
  font-size: clamp(1.125rem, 3vw, 1.5rem);
  font-weight: 700;
  margin: 0;
  color: white;
}

/* Tabs styling */
.product-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--light-bg);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  margin-top: -1rem;
}

.product-tabs::-webkit-scrollbar {
  height: 4px;
}

.product-tabs::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.tab-button {
  padding: clamp(10px, 1.5vh, 12px) clamp(12px, 2vw, 16px);
  padding-bottom: clamp(8px, 1.2vh, 10px);
  border: none;
  background: none;
  font-size: clamp(0.9375rem, 2vw, 1.0625rem);
  font-weight: 800;
  color: #555;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
  flex-shrink: 0;
}

.tab-button.active {
  color: #e07b39;
  border-bottom-color: var(--primary-color);
}

.tab-button:hover:not(.active) {
  background-color: #f0f0f0;
}

/* Product detail section */
.product-detail {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(16px, 3vw, 30px);
  padding: clamp(16px, 2.5vw, 20px);
  overflow-y: auto;
  flex: 1;
  align-items: start;
}

@media (min-width: 768px) {
  .product-detail {
    grid-template-columns: minmax(300px, 45%) 1fr;
    align-items: center;
  }
}

@media (min-width: 1024px) {
  .product-detail {
    grid-template-columns: minmax(400px, 50%) 1fr;
  }
}

.product-image-container {
  width: 100%;
  text-align: center;
}

.product-image {
  width: 100%;
  height: auto;
  max-height: clamp(250px, 40vh, 500px);
  object-fit: contain;
  border-radius: clamp(6px, 1vw, 8px);
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

.product-image:hover {
  transform: scale(1.03);
}

.product-info {
  width: 100%;
}

.product-name {
  font-size: clamp(1rem, 2.5vw, 1.375rem);
  font-weight: 600;
  color: var(--primary-color);
  margin: 0 0 clamp(10px, 1.5vh, 12px) 0;
}

.product-description {
  font-size: clamp(0.875rem, 1.8vw, 0.9375rem);
  color: #555;
  line-height: 1.5;
  margin-bottom: clamp(16px, 2.5vh, 20px);
}

.features-title {
  font-size: clamp(1.125rem, 2.2vw, 1.25rem);
  font-weight: 600;
  color: var(--primary-color);
  margin: clamp(12px, 2vh, 15px) 0 clamp(10px, 1.5vh, 12px) 0;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0 0 clamp(16px, 2.5vh, 20px) 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: clamp(8px, 1.2vh, 10px);
}

.feature-icon {
  color: #4caf50;
  margin-right: clamp(6px, 1vw, 8px);
  font-weight: bold;
  flex-shrink: 0;
  font-size: clamp(1rem, 2vw, 1.125rem);
}

.feature-text {
  font-size: clamp(1rem, 2vw, 1.125rem);
  color: #333;
  line-height: 1.4;
}

.product-actions {
  display: flex;
  gap: clamp(10px, 1.5vw, 12px);
  margin-top: clamp(16px, 2.5vh, 20px);
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  background-color: #e07b39;
  color: white;
  border: none;
  padding: clamp(10px, 1.5vh, 12px) clamp(16px, 3vw, 24px);
  border-radius: clamp(5px, 0.8vw, 6px);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  font-size: clamp(0.9375rem, 2vw, 1rem);
}

.btn-primary {
  background-color: var(--primary-color);
}

.btn-primary:hover {
  background-color: var(--primary-hover);
}

.btn-secondary:hover {
  background-color: #d06b29;
}

.modal-footer {
  border-top: 1px solid var(--border-color);
  padding: clamp(10px, 1.5vh, 12px) clamp(12px, 2vw, 16px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--light-bg);
  margin-top: auto;
}

/* Modal 本體動畫 */
.fade-enter-from .modal-content {
  opacity: 0;
  transform: translateY(30px) scale(0.98);
}

.fade-enter-to .modal-content {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.fade-leave-from .modal-content {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.fade-leave-to .modal-content {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

/* 動畫時間 */
.fade-enter-active .modal-content,
.fade-leave-active .modal-content {
  transition: all 0.35s ease;
}

/* 小螢幕優化 */
@media (max-height: 700px) {
  .modal-header {
    padding: clamp(8px, 1.2vh, 10px) clamp(12px, 2vw, 15px);
  }

  .product-detail {
    padding: clamp(12px, 2vw, 16px);
  }
}
</style>

<script>
export default {
  name: "NewsViewModal",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      zoomLevel: 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      activeTab: 0,
      lightboxVisible: false,
      lightboxImage: "",
      products: [
        {
          id: 1,
          name: "親水塗層導尿包",
          imageUrl: require("@/assets/image/product.webp"),
          description: "",
          features: ["導尿必備品一次齊全"],
        },
      ],
    };
  },
  computed: {
    zoomStyle() {
      return {
        transform: `scale(${this.zoomLevel}) translate(${this.translateX}px, ${this.translateY}px)`,
        transition: this.isDragging ? "none" : "transform 0.2s",
        cursor: this.isDragging ? "grabbing" : "grab",
      };
    },
  },
  emits: ["close", "contact", "learn-more"],
  methods: {
    handleZoom(event) {
      const delta = Math.sign(event.deltaY);
      if (delta > 0) {
        this.zoomLevel = Math.max(1, this.zoomLevel - 0.1);
      } else {
        this.zoomLevel = Math.min(5, this.zoomLevel + 0.1);
      }
    },
    startDragging(event) {
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
    },
    onDragging(event) {
      if (!this.isDragging) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.translateX += dx / this.zoomLevel;
      this.translateY += dy / this.zoomLevel;
    },
    stopDragging() {
      this.isDragging = false;
    },
    closeLightbox() {
      this.lightboxVisible = false;
      this.lightboxImage = "";
      this.zoomLevel = 1;
      this.translateX = 0;
      this.translateY = 0;
    },
    openLightbox(imageUrl) {
      this.lightboxImage = imageUrl;
      this.lightboxVisible = true;
    },

    closeModal() {
      this.$emit("close");
    },
    contactSupport() {
      this.closeModal(); // 關閉Modal
      this.$router.push("/contact"); // 導向聯絡頁面
    },
    learnMore() {
      this.$emit("learn-more", this.products[this.activeTab]);
      this.closeModal();
    },
  },
};
</script>


